module.exports = __webpack_public_path__ + "img/save.d537c041.svg";